<div class="container">

<h1>DATOS DEL SOLICITANTE</h1>

<form class="form-grid" [formGroup]="form" (ngSubmit)="enviar()">

<div class="column">

<div class="form-group">
<label>Nombres</label>
<input type="text" formControlName="nombres">
</div>

<div class="form-group">
<label>Apellidos</label>
<input type="text" formControlName="apellidos">
</div>

<div class="form-group">
<label>RUT</label>
<input type="text" formControlName="rut">
</div>

</div>


<div class="divider"></div>


<div class="column">

<div class="form-group">
<label>Teléfono</label>
<input type="text" formControlName="telefono">
</div>

<div class="form-group">
<label>Correo electrónico</label>
<input type="email" formControlName="correo">
</div>

<div class="form-group">
<label>Dirección - Nro.</label>
<input type="text" formControlName="direccion">
</div>

<div class="row">

<div class="form-group small">
<label>Comuna</label>
<input type="text" formControlName="comuna">
</div>

<div class="form-group small">
<label>Región</label>
<input type="text" formControlName="region">
</div>

</div>

<div class="form-actions">
    <button type="submit">Enviar Solicitud</button>
</div>

@if (mostrarMensaje) {
  <div class="error-banner">
    ⚠️ Por favor complete todos los campos requeridos
  </div>
}

</div>


</form>

</div>

<ng-template #modalCustom let-modal>
  <div #modalContainer>
    <div class="custom-modal">
      <div class="custom-modal-header">
        Solicitud de Certificado de Liquidación de Deuda
      </div>
      <div class="custom-modal-body">
        <p>Su solicitud fue enviada</p>
      </div>
      <div class="custom-modal-footer">
        <button type="button" class="btn btn-rounded" (click)="modal.dismiss('Cross click')">OK</button>
      </div>
    </div>
  </div>
</ng-template>